import { DiagramDefinition } from "../types";

export const m016Definition: DiagramDefinition = {
  id: "M-016",
  title: "Automatic Migration Execution Pipeline",
  description:
    "Comparison of pb_migrations/ JavaScript files against _migrations database table records to construct pending migration list, execute up functions, and update tracking state.",
  viewBox: "0 0 850 200",
  nodes: [
    { id: "A", kind: "service", label: "pb_migrations/", subtext: "Read Files", position: [90, 60], size: [130, 46] },
    { id: "C", kind: "database", label: "_migrations", subtext: "Read Applied", position: [90, 150], size: [130, 46] },
    { id: "E", kind: "service", label: "Compare Sequence", subtext: "Alphanumeric", position: [270, 105], size: [140, 48] },
    { id: "F", kind: "service", label: "Pending List", subtext: "Unapplied JS", position: [450, 105], size: [130, 48] },
    { id: "G", kind: "service", label: "Run up()", subtext: "Execute Code", position: [620, 105], size: [120, 48], statusColor: "#ff5a1f" },
    { id: "H", kind: "database", label: "Update Table", subtext: "Save Batch State", position: [770, 105], size: [110, 48], statusColor: "#ff5a1f" },
  ],
  edges: [
    { id: "e1", source: "A", target: "E", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e2", source: "C", target: "E", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e3", source: "E", target: "F", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "F", target: "G", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e5", source: "G", target: "H", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
  ],
};
